module.exports = __webpack_public_path__ + "img/mais-logo.15f9724d.png";